<template>
    <modal-template style="z-index:9998;">
        <template #header>
            <div style="width:100%;float:left;background:black;color:white;">
                <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
                    <span>maintain an announcement</span>
                </div>
                <div style="float:right;text-align:right;">
                    <label class="close-icon-style" v-on:click="$emit('close', true)">
                        <font-awesome-icon icon="xmark" size="xl"/>
                        <span style="display: block;">close</span>
                    </label>
                </div>
            </div>
            <div style="width:100%;float:left;padding-top:1%;color:black;">
                <div style="float:left;">
                    <div style="font-size:larger;font-weight:bold;">
                        <sup>[{{ dairyid }}]</sup> {{ dairyname }}
                    </div>
                </div>
            </div>
        </template>
        <template #body>
            <div>
                <div>
                    <table>
                        <tbody>
                        <tr>
                            <td>effective date range</td>
                        </tr>
                        <tr>
                            <td>
                                <vue-date-picker v-model="dateRange" :enable-time-picker="false" range/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div>
                        <textarea style="width:100%;height:150px;"
                                  v-model="selectedAnnouncement.message"
                                  maxlength="500">
                        </textarea>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <div>
                <div style="float:left;">
                    <button v-on:click="updateAnnouncement('I')">delete</button>
                </div>
                <div style="float:right;">
                    <button v-if="selectedAnnouncement.message !== ''" v-on:click="updateAnnouncement('A')">save
                    </button>
                </div>
            </div>
        </template>
    </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    name: 'MaintainAnnouncement',
    props: ['dairyid', 'dairyname', 'announcement'],
    emits: ['close', 'apierror', 'apierrortext'],
    data: function () {
        return {
            dateRange: [],
            message: '',
            selectedAnnouncement: Object.assign({}, this.announcement),
        }
    },
    components: {
        ModalTemplate,
        VueDatePicker,
    },
    methods: {
        updateAnnouncement(status) {
            this.selectedAnnouncement.startDate = this.dateRange[0].toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            })

            this.selectedAnnouncement.endDate = this.dateRange[1].toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            })

            this.selectedAnnouncement.status = status
            this.selectedAnnouncement.changedBy = ''
            this.selectedAnnouncement.changedOn = null

            if (this.selectedAnnouncement.createdBy === '') {
                this.selectedAnnouncement.createdBy = this.$store.getters.getUsername
                this.selectedAnnouncement.createdOn = new Date().toISOString().split('.')[0]
            } else {
                if (!_.isEqual(this.announcement, this.selectedAnnouncement)) {
                    this.selectedAnnouncement.changedBy = this.$store.getters.getUsername
                    this.selectedAnnouncement.changedOn = new Date().toISOString().split('.')[0]
                }
            }

            if (!_.isEqual(this.announcement, this.selectedAnnouncement)) {
                this.axios
                    .post('admin/announcement/save', this.selectedAnnouncement)
                    .then(response => {
                        if (response.data) {
                            this.$emit('close', true)
                        } else {
                            this.setApiError(true)
                            this.setApiErrorText('Announcement date range overlaps an existing active announcement')
                        }
                    })
                    .catch(error => {
                        this.setApiError(true)
                        this.setApiErrorText(error.response.statusText)
                    })
            }
        },
        setApiError: function (isError) {
            this.$emit('apierror', isError)
        },
        setApiErrorText: function (text) {
            this.$emit('apierrortext', text)
        }
    },
    mounted() {
        this.dateRange = [new Date(this.selectedAnnouncement.startDate), new Date(this.selectedAnnouncement.endDate)]
    }
}
</script>

<style scoped>
.close-icon-style {
    color: white;
    text-align: center;
    cursor: pointer;
    width: 80px;
}

.close-icon-style:hover {
    font-weight: bolder;
}
</style>
